const palette = {
  primary: {
    main: "#CABA9F",
    contrastText: "#FFFFFF",
  },
  secondary: {
    main: "#1E2022",
    contrastText: "#ffffff",
  },
  text: {
    primary: "#000000",
    
  },
  success: {
    main: "#0E912C",
  },
  common: {
    black: "#000000",
    white: "#FFFFFF",
  },
};

export default palette;
